export const SUBSCRIPTION_CTA =
  'Get instant access to trending webinars. 100% free.'; // Get quality knowledge directly to your inbox. 100% free.
